import { render, staticRenderFns } from "./AcompanhamentoNew.vue?vue&type=template&id=0891a5ee&scoped=true&"
import script from "./AcompanhamentoNew.vue?vue&type=script&lang=js&"
export * from "./AcompanhamentoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0891a5ee",
  null
  
)

export default component.exports